/* global femcare */

femcare.globalLanding.languageDropdown = {
    init: function() {
        if ($('.global-landing-language .has-dropdown').length) {
            this.initDropdowns();
        }
    },

    /**
     * Init language dropdown toggle
     */
    initDropdowns: function() {
        $('.global-landing-language a').on(
            'click',
            $.proxy(function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();

                var $link = $(e.currentTarget);
                var $dropdown = $link.parent('.has-dropdown');

                if ($dropdown.length) {
                    // Before opening the dropdown first close any previously opened
                    if (!$dropdown.hasClass('open')) {
                        $('.has-dropdown.open').each(this.toggleDropdown);
                    }
                    this.toggleDropdown.call($dropdown);
                } else {
                    window.location = $link.attr('href');
                }
            }, this)
        );

        // Close opened dropdown on background click
        $('.global-landing').on(
            'click',
            $.proxy(function() {
                $('.has-dropdown.open').each(this.toggleDropdown);
            }, this)
        );
    },

    /**
     * Toggle the dropdown expand/collapse state
     */
    toggleDropdown: function() {
        var $this = $(this);
        $this.toggleClass('open');
        $this.find('i').toggleClass('icon-arrow-down icon-arrow-up');

        var $dropdownToggle = $this.find('> a');
        $dropdownToggle.attr('aria-expanded', $this.hasClass('open'));
    }
};
